/**
 * Which id space a /rides/:id route parameter belongs to.
 *
 * Confirmed rides are mongo documents (24 hex chars); standby ride requests are
 * postgres rows (UUID). The two are served by different endpoints with
 * different strict validators, so the page has to decide BEFORE it fetches —
 * sending a UUID to /admin/ride/:rideId gets a 400, not a 404.
 */
export const RideIdKind = {
  confirmed: 'confirmed',
  standby: 'standby',
  unknown: 'unknown',
};

const MONGO_OBJECT_ID = /^[0-9a-f]{24}$/i;
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const classifyRideId = (id) => {
  if (typeof id !== 'string') {
    return RideIdKind.unknown;
  }
  if (MONGO_OBJECT_ID.test(id)) {
    return RideIdKind.confirmed;
  }
  if (UUID.test(id)) {
    return RideIdKind.standby;
  }
  return RideIdKind.unknown;
};
